module.exports = __webpack_public_path__ + "img/introduction_2.41ebdc36.png";